const ROOT_SELECTOR = '[data-elx-premium-info]';

function removeExternalTrigger(sectionId, except = null) {
  if (!sectionId) return;

  document.querySelectorAll('[data-elx-premium-owned-by]').forEach((element) => {
    if (element === except) return;
    if (element.dataset.elxPremiumOwnedBy === sectionId) element.remove();
  });
}

function initPremiumInfo(root) {
  if (!(root instanceof HTMLElement) || root.dataset.elxPremiumReady === 'true') return;

  const trigger = root.querySelector('[data-elx-premium-trigger]');
  const panel = root.querySelector('[data-elx-premium-panel]');
  const backdrop = root.querySelector('[data-elx-premium-backdrop]');
  const closeButton = root.querySelector('[data-elx-premium-close]');

  if (!(trigger instanceof HTMLButtonElement) || !(panel instanceof HTMLElement) || !(backdrop instanceof HTMLElement)) return;

  const sectionId = root.dataset.elxPremiumSectionId || '';
  const placement = root.dataset.elxPremiumPlacement || 'under_gallery';

  root.dataset.elxPremiumReady = 'true';
  let isOpen = false;

  removeExternalTrigger(sectionId, trigger);

  const placeTrigger = () => {
    if (placement === 'under_gallery') {
      const mediaColumn = document.querySelector('.elixiva-pdp__media-column');
      if (mediaColumn && trigger.parentElement !== mediaColumn) mediaColumn.appendChild(trigger);
    }

    trigger.classList.add('is-mounted');
  };

  const getFocusable = () => Array.from(
    panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')
  ).filter((element) => element instanceof HTMLElement && !element.hasAttribute('hidden'));

  const unlockPage = () => {
    if (document.querySelector('.elx-premium-info__panel.is-open')) return;
    document.documentElement.classList.remove('elx-premium-info-open');
    document.body.classList.remove('elx-premium-info-open');
  };

  const close = ({ restoreFocus = true } = {}) => {
    if (!isOpen) return;
    isOpen = false;
    panel.classList.remove('is-open');
    backdrop.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
    trigger.setAttribute('aria-expanded', 'false');
    unlockPage();

    if (restoreFocus && document.contains(trigger)) {
      window.setTimeout(() => trigger.focus({ preventScroll: true }), 20);
    }
  };

  const open = () => {
    if (isOpen) return;
    isOpen = true;
    panel.classList.add('is-open');
    backdrop.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    trigger.setAttribute('aria-expanded', 'true');
    document.documentElement.classList.add('elx-premium-info-open');
    document.body.classList.add('elx-premium-info-open');

    window.requestAnimationFrame(() => {
      if (closeButton instanceof HTMLElement) closeButton.focus({ preventScroll: true });
      else panel.focus({ preventScroll: true });
    });
  };

  trigger.addEventListener('click', () => (isOpen ? close() : open()));
  backdrop.addEventListener('click', () => close());
  closeButton?.addEventListener('click', () => close());

  const handleKeydown = (event) => {
    if (!isOpen) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      close();
      return;
    }

    if (event.key !== 'Tab') return;
    const focusable = getFocusable();

    if (focusable.length === 0) {
      event.preventDefault();
      panel.focus();
      return;
    }

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  };

  document.addEventListener('keydown', handleKeydown);

  root._elxPremiumCleanup = () => {
    close({ restoreFocus: false });
    document.removeEventListener('keydown', handleKeydown);
    removeExternalTrigger(sectionId);
    unlockPage();
  };

  placeTrigger();
}

function initPremiumInfoWithin(scope = document) {
  if (scope instanceof HTMLElement && scope.matches(ROOT_SELECTOR)) initPremiumInfo(scope);
  scope.querySelectorAll?.(ROOT_SELECTOR).forEach(initPremiumInfo);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initPremiumInfoWithin(document), { once: true });
} else {
  initPremiumInfoWithin(document);
}

document.addEventListener('shopify:section:load', (event) => {
  window.requestAnimationFrame(() => initPremiumInfoWithin(event.target));
});

document.addEventListener('shopify:section:unload', (event) => {
  const sectionId = event.detail?.sectionId || event.target?.id?.replace('shopify-section-', '') || '';
  const root = event.target?.querySelector?.(ROOT_SELECTOR);
  root?._elxPremiumCleanup?.();
  removeExternalTrigger(sectionId);

  if (!document.querySelector('.elx-premium-info__panel.is-open')) {
    document.documentElement.classList.remove('elx-premium-info-open');
    document.body.classList.remove('elx-premium-info-open');
  }
});
